import {Storage} from "../../../Services/Storage";
import axios from "axios";
import router from "../../../router";

/**
 * Determine whether a user account is archived.
 * Supports both `archived` and `archive` flags and normalizes common value types.
 * @param {Object} user - User object from storage/API
 * @returns {boolean} true if archived, false otherwise
 */
function isArchivedUser(user) {
    const v = user && (user.archived !== undefined ? user.archived : user.archive);
    if (typeof v === 'string') {
        const s = v.toLowerCase();
        return s === 'true' || s === '1' || s === 'yes';
    }
    if (typeof v === 'number') return v === 1;
    return !!v; // handles boolean and undefined safely
}

/**
 * Normalize various truthy/falsey representations to strict booleans.
 * Accepts: true/false, "true"/"false", "1"/"0", 1/0, "yes"/"no".
 * This helper is used only on submit — forms remain unchanged per guidelines.
 * @param {*} v
 * @returns {boolean}
 */
function toBool(v) {
    if (typeof v === 'boolean') return v;
    if (typeof v === 'number') return v === 1;
    if (typeof v === 'string') {
        const s = v.trim().toLowerCase();
        return s === 'true' || s === '1' || s === 'yes';
    }
    return !!v;
}

/**
 * Ensure employee payload fields expected as booleans are booleans before API submit.
 * Do not mutate original payload; return a sanitized shallow copy.
 *
 * Note: We intentionally keep the form model unchanged and sanitize here on submit
 * to comply with: "Do not add the Boolean to the form just sanitize on submit".
 * @param {Object} payload
 * @returns {Object}
 */
function sanitizeEmployeePayload(payload) {
    const p = { ...payload };
    // Extend this list as backend evolves
    const boolFields = [
        'use2FA',
        'archived',
        'archive',
        'enabled',
        'active',
        'isSupervisor',
        'canLogin',
    ];
    boolFields.forEach((k) => {
        if (k in p) p[k] = toBool(p[k]);
    });
    // Remove empty phone_number to preserve existing value on backend
    if (p.phone_number === "" || p.phone_number === null || p.phone_number === undefined) {
        delete p.phone_number;
    }
    return p;
}

export default {
    name: 'user',
    state: {
        allUsers: [],
        attemptedLoginRoute : { name : `stock` },

        currentUser: {}
    },
    getters: {
        getAllUsers: (state) => state.allUsers,
        getAttemptedRoute: (state) => state.attemptedLoginRoute,
        getCurrentUser: (state) => state.currentUser,
    },
    mutations: {
        setAllUsers: async (state, payload) => {
            if (payload) await Storage.setAllUsers(payload)
            else payload = await Storage.getAllUsers();
            state.allUsers = payload ? payload : [];
        },
        setAttemptedRoute: (state, data) => state.attemptedLoginRoute = data,
        setSessionID:async (state , data) => {
            if (data) await Storage.setSessionID(data)
            else data = await Storage.getSessionID();
            state.current_session = data;
        },
        setCurrentUser: async (state, payload) => {
            if (payload) await Storage.setCurrentUser(payload)
            else payload = await Storage.getCurrentUser();
            state.currentUser = payload ? payload : {};
        },
    },
    actions: {
        verifyOtp: (context, payload) => {
            // console.log("Payload:", payload);

            // Send POST request to verify OTP
            return axios
                .post(ticketApi + "support/verifyOTP", payload)
                .then(async ({ data }) => {
                    // console.log("Response Data:", data);

                    // Navigate to the route first
                    const route = { name: "stock" }; // Replace 'stock' with the desired route name
                    router.push(route);


                    // Perform the second POST request after navigation
                    const loggedUser = Storage.getItem("Supportlogged in user");

                    const storeDB = await Storage.getCurrentStoreDB();
                     const deviceID = await Storage.getDeviceID();

                    const loginPayload = {
                        username: loggedUser,
                        platform: "OnlineBackOffice",
                        pc: deviceID,
                    };

                    return axios.post(
                        `${serverApi}supervisorOverrides/${storeDB}/recordLogin`,
                        loginPayload
                    );
                })
                .catch((err) => {
                    console.error("Error during OTP verification:", err);
                    return errorHandler.tomcatError(err);
                });
        },

        // verifyOtp: (context, payload) => {
        //     console.log(payload)
        //     return axios.post(ticketApi + 'support/verifyOTP', payload)
        //         .then(({data}) => {
        //             context.commit(`setSessionID`,data)
        //             let route = context.getters.getAttemptedRoute;
        //             let routeName = route.name;
        //             const resolvedRoute = router.resolve({ name: routeName });
        //             let exists = resolvedRoute.route.name === routeName;
        //             if(!exists) route = { name : `stock` };
        //             return router.push(route);
        //         }).catch(err => errorHandler.tomcatError(err));
        // },
        getAllUsers: async (context) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.get(backOfficeTomcatApi + `users/${storeDB}/getAll`)
                .then(({data}) => context.commit('setAllUsers', data))
                .catch(err => errorHandler.tomcatError(err))
        },
        createEmployee: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            const safe = sanitizeEmployeePayload(payload);
            return axios.post(franchiseTomcatApi + `employee/${storeDB}`, safe)
                .then(() => context.dispatch('getAllUsers'))
                .catch((err) => {
                    if (err && err.response && err.response.status === 409) {
                        throw err;
                    }
                    return errorHandler.tomcatError(err);
                })
        },
        createFranchiseEmployee: async (context, payload) => {
             return axios.post(backoffice + `api/franchise`, payload)
                 .catch((err) => errorHandler.tomcatError(err))
        },
        editEmployee: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            const safe = sanitizeEmployeePayload(payload);
            return axios.put(franchiseTomcatApi + `employee/${storeDB}/${payload.id}`, safe)
                .then(() => context.dispatch(`getAllUsers`))
                .catch((err) => {
                    if (err && err.response && err.response.status === 409) {
                        throw err;
                    }
                    return errorHandler.tomcatError(err);
                })
        },
        FranchiseeditEmployee: async (context, payload) => {
            const { idn, ...newPayload } = payload; // Remove 'idn' from the payload
            return axios.put(backoffice + `api/franchise/${idn}`, newPayload)
                .catch((err) => errorHandler.tomcatError(err));
        },


        deleteEmployee: async (context, id) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.delete(franchiseTomcatApi + `employee/${storeDB}/${id}`)
                .then(() => context.dispatch(`getAllUsers`))
                .catch((err) => errorHandler.tomcatError(err))
        },
        deleteFranchsieEmployee: async (context, id) => {
             return axios.put(backoffice + `api/franchise/change-status/${id}?archive=true`)
                 .catch((err) => errorHandler.tomcatError(err))
        },
        /**
         * Validate user by password only (used in flows without store pre-checks).
         * Server-side Argon2id verify via empAuth/{storeDB}/login. Blocks archived users.
         * @param context
         * @param {string} password
         * @returns {Promise<boolean>} true if login allowed and committed; false otherwise
         */
        validateUser2: async (context, password) => {
            const storeDB = await Storage.getCurrentStoreDB();
            if (!storeDB) return false;
            const trimmed = String(password || '').trim();
            if (!trimmed) return false;
            let resp;
            try {
                const { data } = await axios.post(
                    franchiseTomcatApi + `posAuth/${storeDB}/login`,
                    { password: trimmed }
                );
                resp = data;
            } catch (e) {
                if (e && e.response && e.response.status === 401) return false;
                if (e && e.response && e.response.status === 409) {
                    responses.throwErr('Multiple employees share this PIN; contact your supervisor');
                    return false;
                }
                if (e && e.response && e.response.status >= 500) {
                    responses.throwErr('Service unavailable; try again');
                    return false;
                }
                return errorHandler.tomcatError(e);
            }
            if (!resp || !resp.success) {
                if (resp && resp.requires2FA) {
                    responses.throwErr('Supervisor requires 2FA — not yet supported here');
                    return false;
                }
                return false;
            }
            const users = await Storage.getAllUsers();
            const user = Array.isArray(users)
                ? users.find(u => u.id === resp.empId
                    || (u.Username && resp.username
                        && u.Username.toLowerCase() === resp.username.toLowerCase()))
                : null;
            if (!user) return false;

            if (isArchivedUser(user)) {
                responses.throwErr('Your account is archived. Please contact your administrator.');
                return false;
            }
            await context.commit('setCurrentUser', user);
            return true;
        },
        /**
         * Validate user by password with storeDB pre-check.
         * Server-side Argon2id verify via empAuth/{storeDB}/login.
         * Blocks archived users and preserves boolean return contract.
         * @param context
         * @param {string} password
         * @returns {Promise<boolean>}
         */
        validateUser: async (context, password) => {
            const storeDB = await Storage.getCurrentStoreDB();
            if (!storeDB) return router.push({ name: 'login' });

            const trimmed = String(password || '').trim();
            if (!trimmed) return false;
            let resp;
            try {
                const { data } = await axios.post(
                    franchiseTomcatApi + `posAuth/${storeDB}/login`,
                    { password: trimmed }
                );
                resp = data;
            } catch (e) {
                if (e && e.response && e.response.status === 401) return false;
                if (e && e.response && e.response.status === 409) {
                    responses.throwErr('Multiple employees share this PIN; contact your supervisor');
                    return false;
                }
                if (e && e.response && e.response.status >= 500) {
                    responses.throwErr('Service unavailable; try again');
                    return false;
                }
                return errorHandler.tomcatError(e);
            }
            if (!resp || !resp.success) {
                if (resp && resp.requires2FA) {
                    responses.throwErr('Supervisor requires 2FA — not yet supported here');
                    return false;
                }
                return false;
            }
            const users = await Storage.getAllUsers();
            const user = Array.isArray(users)
                ? users.find(u => u.id === resp.empId
                    || (u.Username && resp.username
                        && u.Username.toLowerCase() === resp.username.toLowerCase()))
                : null;
            if (!user) return false;

            if (isArchivedUser(user)) {
                responses.throwErr('Your account is archived. Please contact your administrator.');
                return false;
            }
            await context.commit('setCurrentUser', user);
            context.dispatch('checkSmartInvoicing');
            return true;
        }

    }
}
